// constants.js
export const LANGUAGE_OPTIONS = [
    { code: "en", name: "English" },
    { code: "gj", name: "Gujarati" },
    { code: "hi", name: "Hindi" },
    { code: "ma", name: "Marathi" },
    { code: "ba", name: "Bengali" },
  ];
  
  export const AREA_OPTIONS = [
    { name: "Vastrapur", coordinates: [72.5089, 23.0301] },
    { name: "Satellite", coordinates: [72.5119, 23.0100] },
    // Add more areas as needed
  ];
  